<template>
  <div>
    <div class="das_top_cont deduction_record_root">
      <div class="history_box account_input">
        <div class="accountright_cont_box">
          <h2 class="history_box-head spec_title deduction_record_root_title">
            {{ $t("AccountCenterMenu.CreditDeductions") }}
          </h2>
          <div class="his_sel_box" style="width: 100%;display: flex;flex-direction: column;flex: 1;">
            <el-table class="spec_table deduction_record_root_table" :data="yourUsagelist" style="width: 100%"
              empty-text="No Data">
              <el-table-column prop="createTime" :label="$t('MyDatabase.Date')" align="left" width="150"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="UserAccount" :label="$t('BillingandPayment.UserAccount')" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.email }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="companyName" min-width="220"
                class-name="company company_link company_link_tooltip_normal" :label="$t('MyDatabase.CompanyName')"
                align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content company_link" @click="setid(scope.row)" style="">
                    {{ scope.row.companyName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="consumptionPoints" :label="$t('BillingandPayment.CreditUsage')" min-width="160"
                align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.consumptionPoints
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="cpmNoStatus" :label="$t('BillingandPayment.ReportOrderStatus')" align="left"
                show-overflow-tooltip width="240">
                <template slot-scope="scope">
                  <span class="table-content" v-if="scope.row.cpmNoStatus == 1">Finished
                  </span>
                  <span class="table-content" v-if="scope.row.cpmNoStatus == 2">In progress</span>
                  <span class="table-content" v-if="scope.row.cpmNoStatus == 3">Production failed</span>
                </template>
              </el-table-column>
              <el-table-column width="120" prop="" :label="$t('BillingandPayment.Download')" align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content flex_center" @click="Down(scope.row)">
                    <svg t="1723022129119" class="icon" v-if="scope.row.isDownloadFile == false" viewBox="0 0 1024 1024"
                      version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6324" width="28" height="28">
                      <path
                        d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                        fill="#1296db" p-id="6325"></path>
                    </svg>
                    <svg t="1725877594421" class="icon" v-else viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="5401" width="28" height="28">
                      <path
                        d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                        fill="#999999" p-id="5402"></path>
                    </svg>
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <div class="page_i_box" v-if="yourUsagelist.length > 0">
              <Page :totalFont="true" :total="page.total" :pageSize.sync="page.pageSize" :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"></Page>

              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                  <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span> results for "{{
                  $t("AccountCenterMenu.CreditDeductions")
                }}"
              </div>
            </div>
            <!-- <div style="text-align:  center; padding-top: 20px" v-if="this.page.total>this.page.pageSize" class="show_AllHeight">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getUserConsumptionPage,
  getbillingAndPaymentStatistics,
  getUserRechargesPdfAddress,
} from "@/api/userApi";
import { getOfflinePdf } from "@/api/userApi";
import ReLogin from "../../../components/ReLogin.vue";
import Page from "@/components/page/index.vue";
export default {
  mixins: [mixins1],
  components: {
    ReLogin,
    Page,
  },
  data() {
    return {
      reLoginVis: false,
      value1: "",
      CategoryVal: "",
      IndicatorsValType: "",
      type: [],
      IndicatorsValStatus: "",
      yourUsagelist: [],
      window: window,
      page: {
        pageSize: 5,
        pageNo: 1,
        total: 0,
      },
    };
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() {
    this.getgetUserActionLogPage();
  },

  methods: {
    // 点击跳转
    setid(row) {
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.companyAaaid +
          "/background/snapshot?id3a=" +
          row.companyAaaid +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    //下载
    Down(scope) {
      if (scope.isDownloadFile == false) {
        getOfflinePdf(scope.id).then((res) => {
          if (res.code == 200) {
            window.open(res.data, "_blank");
            this.getgetUserActionLogPage();
          } else {
            this.$message.error(res.msg);
          }
        });
        // window.open(scope.fileUrl, '_blank');
      } else {
      }
    },
    // 获取页面数据
    getgetUserActionLogPage() {
      getUserConsumptionPage({
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
        .then((res) => {
          if (res.code == 200) {
            this.yourUsagelist = res.data.rows;
            this.page.total = res.data.total;
          } else {
            this.yourUsagelist = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getgetUserActionLogPage();
    },
    currtentPageChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getgetUserActionLogPage();
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5;
      this.getgetUserActionLogPage();
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 12px;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 16px;
  height: 16px;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 9px;
  font-size: 16px;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 4px;
}

.item_txt {
  font-size: 22px;
  text-align: center;
}

.cont_m {
  margin-top: 26px;
  margin-bottom: 70px;
}

.country_box {
  margin-top: 52px;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 18px;
}

.title_txt {
  font-size: 14px;
  font-family: "Arial Bold";
}

.title_txt img {
  width: 18px;
  margin-right: 7px;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 9px 18px;
  background: #1290c9;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 18px;
}

.btn_blue img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.sel_box {
  margin-right: 22px;
  /* width: 23.928571428571427rem; */
  height: 36px;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 7px;
  font-size: 14px;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 18px;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 54px;
  height: 54px;
  line-height: 68px;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: center;
}

.top_tab {
  margin-top: 35px;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table th.el-table__cell>.cell {
  font-family: "Arial Bold";
}

.last-colmun {
  padding: 25px 0;
  border-bottom: 1px solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -26px;
  right: 0;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 26px !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 18px;
  color: #8c939d;
  width: 62px;
  height: 62px;
  line-height: 62px;
  text-align: center;
}

/deep/ .avatar {
  width: 62px;
  height: 62px;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 3px;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 14px;
  margin-left: -4px;
  color: #1a2332;
  /* float: left; */
  line-height: 28px;
  position: relative;
  left: 47%;
}

.accountright_cont_box {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  min-height: calc(100vh - 152px);
}

.history_box-head {
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 24px;
  color: #1A2332;
  line-height: 34px;
  text-align: left;
  font-style: normal;
}

.account_input .spec_title {
  margin-bottom: 16px;
}

.deduction_record_root_table ::v-deep {
  height: auto;
  overflow-y: auto;
  border: none;
  border-collapse: collapse;
}

.deduction_record_root_table ::v-deep thead,
.deduction_record_root_table ::v-deep .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.deduction_record_root_table ::v-deep td,
.deduction_record_root_table ::v-deep td.el-table__cell {
  min-height: 60px !important;
  height: 60px !important;
}

.deduction_record_root_table ::v-deep .el-table__body-wrapper .el-table__row td:last-child,
.deduction_record_root_table ::v-deep .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.deduction_record_root_table::after {
  display: none !important;
}

.deduction_record_root_table.el-table {
  overflow: hidden;
}

.deduction_record_root_table ::v-deep .el-table__cell:first-child>.cell {
  padding-left: 20px !important;
}

.deduction_record_root_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
  padding-right: 20px !important;
}

.deduction_record_root_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
  text-align: center;
  padding-right: 20px !important;
}

.deduction_record_root_table.el-table ::v-deep th.el-table__cell>.cell {
  font-family: 'Arial bold';
}

.deduction_record_root_table.el-table ::v-deep .cell,
.deduction_record_root_table.el-table ::v-deep .cell .table-content {
  font-size: 18px !important;
  line-height: 24px;
  color: #1A2332;
  font-family: 'Arial';
  text-align: left;
  font-style: normal;
}

.deduction_record_root_table.el-table ::v-deep .cell .company_link {
  color: #1290C9;
  text-decoration-line: underline;
}

.deduction_record_root_table.el-table ::v-deep .icon {
  width: 28px;
  height: 28px;
}

.deduction_record_root_title {
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 24px;
  color: #1290c9;
  line-height: 34px;
  text-align: left;
  font-style: normal;
}

@media screen and (max-width: 1920px) {
  .das_top_item .item_img img {
    width: 12px;
    height: 12px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 7px 0 7px;
  }

  .das_top_item .item_group {
    margin-left: 7px;
    font-size: 12px;
  }

  .das_top_item .item_lab {
    margin-top: 3px;
  }

  .item_txt {
    font-size: 16px;
  }

  .cont_m {
    margin-top: 20px;
    margin-bottom: 52px;
  }

  .country_box {
    margin-top: 40px;
  }

  .title {
    margin-bottom: 14px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 14px;
    margin-right: 5px;
  }

  .btn_blue {
    padding: 7px 14px;
    font-size: 14px;
  }

  .btn_blu {
    margin-right: 14px;
  }

  .btn_blue img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .sel_box {
    margin-right: 16px;
    height: 28px;
  }

  .sel_box /deep/ .el-input__inner {
    border-radius: 5px;
    font-size: 12px;
  }

  .das_top_item {
    padding: 14px;
  }

  .das_top_item .item_img {
    width: 40px;
    height: 40px;
    line-height: 52px;
  }

  .das_top_item .item_title {
    font-size: 14px;
    margin: 7px 0 7px;
  }

  .top_tab {
    margin-top: 26px;
  }

  .last-colmun {
    padding: 18px 0;
  }

  .dingwei {
    top: -20px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 20px !important;
  }

  ::v-deep .avatar-uploader .el-upload {
    border-radius: 4px;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 16px;
    width: 48px;
    height: 48px;
    line-height: 48px;
  }

  ::v-deep .avatar {
    width: 48px;
    height: 48px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 12px;
    margin-left: -3px;
    line-height: 22px;
  }

  .accountright_cont_box {
    padding-bottom: 10px;
    min-height: calc(100vh - 136px);
  }

  .history_box-head {
    font-size: 18px;
    line-height: 26px;
  }

  .account_input .spec_title {
    margin-bottom: 15px;
  }

  .deduction_record_root_table ::v-deep thead,
  .deduction_record_root_table ::v-deep .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .deduction_record_root_table ::v-deep td,
  .deduction_record_root_table ::v-deep td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .deduction_record_root_table ::v-deep .el-table__cell:first-child>.cell {
    padding-left: 15px !important;
  }

  .deduction_record_root_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
    padding-right: 15px !important;
  }

  .deduction_record_root_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
    padding-right: 15px !important;
  }

  .deduction_record_root_table.el-table ::v-deep .cell,
  .deduction_record_root_table.el-table ::v-deep .cell .table-content {
    font-size: 16px !important;
    line-height: 18px;
  }

  .deduction_record_root_table.el-table ::v-deep .icon {
    width: 22px;
    height: 22px;
  }

  .deduction_record_root_title {
    font-size: 20px;
    line-height: 40px;
  }
}

@media screen and (max-width: 1439px) {
  .das_top_item .item_img img {
    width: 10px;
    height: 10px;
  }

  .das_top_item .item_title {
    font-size: 10px;
    margin: 6px 0 6px;
  }

  .das_top_item .item_group {
    margin-left: 6px;
    font-size: 10px;
  }

  .das_top_item .item_lab {
    margin-top: 3px;
  }

  .item_txt {
    font-size: 14px;
  }

  .cont_m {
    margin-top: 17px;
    margin-bottom: 48px;
  }

  .country_box {
    margin-top: 34px;
  }

  .title {
    margin-bottom: 12px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 12px;
    margin-right: 5px;
  }

  .btn_blue {
    padding: 6px 12px;
    font-size: 12px;
  }

  .btn_blu {
    margin-right: 12px;
  }

  .btn_blue img {
    width: 10px;
    height: 10px;
    margin-right: 3px;
  }

  .sel_box {
    margin-right: 14px;
    height: 24px;
  }

  .sel_box /deep/ .el-input__inner {
    border-radius: 5px;
    font-size: 12px;
  }

  .das_top_item {
    padding: 12px;
  }

  .das_top_item .item_img {
    width: 38px;
    height: 38px;
    line-height: 46px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 6px 0 6px;
  }

  .top_tab {
    margin-top: 24px;
  }

  .last-colmun {
    padding: 16px 0;
  }

  .dingwei {
    top: -17px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 17px !important;
  }

  ::v-deep .avatar-uploader .el-upload {
    border-radius: 3px;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 14px;
    width: 42px;
    height: 42px;
    line-height: 42px;
  }

  ::v-deep .avatar {
    width: 42px;
    height: 42px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 12px;
    margin-left: -3px;
    line-height: 18px;
  }

  .accountright_cont_box {
    padding-bottom: 0;
    min-height: calc(100vh - 126px);
  }

  .history_box-head {
    font-size: 16px;
    line-height: 22px;
  }

  .account_input .spec_title {
    margin-bottom: 10px;
  }

  .deduction_record_root_table ::v-deep thead,
  .deduction_record_root_table ::v-deep .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .deduction_record_root_table ::v-deep td,
  .deduction_record_root_table ::v-deep td.el-table__cell {
    min-height: 40px !important;
    height: 40px !important;
  }

  .deduction_record_root_table ::v-deep .el-table__cell:first-child>.cell {
    padding-left: 12px !important;
  }

  .deduction_record_root_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
    padding-right: 12px !important;
  }

  .deduction_record_root_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
    padding-right: 12px !important;
  }

  .deduction_record_root_table.el-table ::v-deep .cell,
  .deduction_record_root_table.el-table ::v-deep .cell .table-content {
    font-size: 14px !important;
    line-height: 16px;
  }

  .deduction_record_root_table.el-table ::v-deep .icon {
    width: 18px;
    height: 18px;
  }

  .deduction_record_root_title {
    font-size: 16px;
    line-height: 18px;
  }
}
</style>
